<template>
  <div class="administration">
    <usersNew />
    <usersList />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import viewLoader from "@/components/view_loader";

import usersNew from "@/components/administration/users_new";
import usersList from "@/components/administration/users_list";

export default {
  components: {
    usersNew,
    usersList,
    viewLoader,
  },

  computed: {
    ...mapState("users", ["users"]),
  },

  methods: {
    ...mapActions("users", ["fetchUsers"]),
  },

  mounted() {
    this.fetchUsers();
  },
};
</script>
<style scoped>
/* The app is a fixed-height viewport (#app: 100vh, overflow hidden), so the
   view fills the layout's content column and the users table scrolls inside */
.administration {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
</style>